import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import yachtClubAnchor from "@/assets/yacht-club-anchor.jpg";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="py-12 bg-background border-t border-border relative z-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center gap-8">
          <div className="flex items-end justify-between w-full max-w-md">
            <div className="flex-1 flex justify-start">
              <div 
                onClick={() => navigate('/yacht-club')}
                className="cursor-pointer group relative"
                aria-label="Join Park Row Yacht Club"
              >
                <div className="relative w-20 h-20 rounded-lg overflow-hidden border border-border/20 shadow-lg backdrop-blur-sm transition-all duration-300 group-hover:scale-105 group-hover:border-primary/30 group-hover:shadow-primary/20">
                  <div className="absolute inset-0 bg-gradient-to-b from-background/40 to-background/20 mix-blend-overlay z-10" />
                  <img 
                    src={yachtClubAnchor}
                    alt="Park Row Yacht Club"
                    className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              </div>
            </div>
            
            <a 
              href="https://x.com/ParkRowX" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-foreground hover:text-primary transition-colors duration-300 flex-shrink-0"
              aria-label="X (formerly Twitter)"
            >
              <X className="h-6 w-6" />
            </a>
            
            <div className="flex-1 flex justify-end">
              <div 
                onClick={() => navigate('/division-street')}
                className="cursor-pointer"
                aria-label="Park Row Drive"
              >
                <svg 
                  width="40" 
                  height="80" 
                  viewBox="0 0 40 80" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <radialGradient id="lampGlow" cx="50%" cy="50%" r="50%">
                      <stop offset="0%" stopColor="hsl(40, 100%, 70%)" stopOpacity="1"/>
                      <stop offset="50%" stopColor="hsl(35, 100%, 60%)" stopOpacity="0.8"/>
                      <stop offset="100%" stopColor="hsl(30, 100%, 50%)" stopOpacity="0"/>
                    </radialGradient>
                    <radialGradient id="lightCone" cx="50%" cy="0%" r="80%">
                      <stop offset="0%" stopColor="hsl(40, 100%, 65%)" stopOpacity="0.4"/>
                      <stop offset="50%" stopColor="hsl(35, 100%, 60%)" stopOpacity="0.2"/>
                      <stop offset="100%" stopColor="hsl(30, 100%, 50%)" stopOpacity="0"/>
                    </radialGradient>
                  </defs>
                  
                  <ellipse cx="20" cy="32" rx="18" ry="24" fill="url(#lightCone)" />
                  <ellipse cx="20" cy="16" rx="14" ry="10" fill="url(#lampGlow)" />
                  <rect x="14" y="8" width="12" height="16" rx="2" className="fill-muted-foreground" />
                  <ellipse cx="20" cy="16" rx="7" ry="5" fill="hsl(45, 100%, 75%)" />
                  <rect x="18.5" y="22" width="3" height="8" className="fill-muted-foreground" />
                  <rect x="18" y="28" width="4" height="44" className="fill-muted-foreground" />
                  <rect x="14" y="70" width="12" height="4" rx="1" className="fill-muted-foreground" />
                  <rect x="12" y="74" width="16" height="6" rx="2" className="fill-muted-foreground/80" />
                </svg>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-xs font-medium">
            <a 
              href="/division-street#sunny-juke-joint" 
              className="text-primary hover:text-primary/80 transition-colors duration-300 font-semibold tracking-wide flex items-center gap-1"
            >
              🎵 LISTEN AT SUNNY'S
            </a>
            <a 
              href="/yacht-club" 
              className="text-primary hover:text-primary/80 transition-colors duration-300 font-semibold tracking-wide"
            >
              YACHT CLUB
            </a>
            <a 
              href="/fan-auth" 
              className="text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              LOGIN
            </a>
            <a 
              href="/careers" 
              className="text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              CAREERS
            </a>
            <a 
              href="/privacy-policy" 
              className="text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              PRIVACY POLICY
            </a>
            <a 
              href="/sponsors" 
              className="text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              SPONSORS
            </a>
          </div>

          <p className="font-medium text-muted-foreground text-xs tracking-[0.02em]">
          © {new Date().getFullYear()} Park Row. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;

// Add streetlamp styles to index.css if needed
